import { Icon, IconProps } from '@chakra-ui/react';

export default function CodeBracketIcon({ ...props }: IconProps) {
  return (
    <Icon viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M72.6875 37.48L89.2493 54.0418L72.6875 70.6035"
        stroke="#F9D357"
        strokeWidth="3.02222"
        strokeLinejoin="round"
      />
      <path
        d="M34.5618 37.48L18 54.0418L34.5618 70.6035"
        stroke="#F9D357"
        strokeWidth="3.02222"
        strokeLinejoin="round"
      />
      <path
        d="M63.2438 30L44.0225 77.7813"
        stroke="#F9D357"
        strokeWidth="3.02222"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
